import { signal } from '@angular/core';


export const globalClientId = signal<string | null>(null);
